module.exports = __webpack_public_path__ + "img/lucky_bk_p2.9e2703a9.png";